import RentToOwn from "./RentToOwn";

export default RentToOwn;
